import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en/index.json'
import ru from './locales/ru/index.json'

export const langs = { en, ru } as const
const ns = ['common', 'app'] as const

const supportedLngs = Object.keys(langs)

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  debug: import.meta.env.VITE_DEBUG === 'debug',
  react: {
    useSuspense: false,
  },
  defaultNS: 'common',
  ns,
  supportedLngs,
  resources: {},
})

Object.entries(langs).forEach(([lang, data]) => {
  Object.entries(data).forEach(([nsKey, nsValue]) => {
    i18n.addResourceBundle(lang, nsKey, nsValue, true, true)
  })
})

export default i18n
